<template>
    <div style="width: 250px" class="mb-5 mt-5 media-card">
        <div ref="dashboardContainer"></div>
        <div ref="dashboardProgress"></div>
    </div>
</template>

<script>
import {mapMutations, mapState} from "vuex"
import Uppy from "@uppy/core"
import Dashboard from "@uppy/dashboard"
import ProgressBar from "@uppy/progress-bar"
import AwsS3 from "@uppy/aws-s3"
import French from "@uppy/locales/lib/fr_FR"

import '@uppy/core/dist/style.css'
import '@uppy/dashboard/dist/style.css'
import '@uppy/progress-bar/dist/style.css'

export default {
    name: "MediaUpload",
    data() {
        return {
            uppy: null,
        }
    },
    methods: {
        ...mapMutations('web_form', ['addMedia', "setDirtyTabulation",]),
        dec2hex(dec) {
            return dec < 10
              ? '0' + String(dec)
              : dec.toString(16)
        },
        generateId(len) {
            let arr = new Uint8Array((len || 40) / 2)
            window.crypto.getRandomValues(arr)
            return Array.from(arr, this.dec2hex).join('')
        },
        loadCss() {
            let border = document.getElementsByClassName('uppy-Dashboard')
            let button = document.querySelector('.uppy-Dashboard button')

            if (border !== null && border !== undefined && border.length) {
                border[0].style.setProperty('border-color', this.primaryColor, 'important')
            }

            if (button !== null && button !== undefined) {
                button.style.setProperty('color', this.primaryColor, 'important')
            }
        },
        async getExifMetadata(path) {
            let payload = {
                url: path
            }

            let res = await this.$http.post('exif-copyright', payload)

            return res.body
        },
        pushMedia(originUrl, thumbnailUrl, source = null, temp = true, copyright = null, height = null, width = null) {
            let media = {
                thumbnail_url: thumbnailUrl,
                name: null,
                copyright: copyright,
                temp: temp,
                origin_url: originUrl,
                source: source,
                is_image: true,
                height: height,
                width: width
            }

            this.setDirtyTabulation('MEDIAS')
            this.addMedia(media)
        }
    },
    computed: {
        ...mapState("webFormStyle", ['primaryColor']),
    },
    async mounted() {
        if (!this.disabled) {
            let self = this

            this.uppy = Uppy({
                debug: true,
                autoProceed: true,
                locale: French,
                restrictions: {
                    maxFileSize: 9500000,
                    allowedFileTypes: ['image/png', 'image/jpeg', 'image/gif', 'image/bmp']
                }
            }).use(Dashboard, {
                hideUploadButton: true,
                inline: true,
                height: 287,
                width: 'auto',
                target: this.$refs.dashboardContainer,
                replaceTargetContent: true,
                showProgressDetails: true,
                browserBackButtonClose: true,
                theme: 'light',
                locale: {
                    strings: {
                        dropPaste: '%{browse}',
                        browse: 'Ajouter un média',
                    }
                },
                proudlyDisplayPoweredByUppy: false,
                showSelectedFiles: false
            }).use(ProgressBar, {
                target: this.$refs.dashboardProgress,
                hideAfterFinish: false
            }).use(AwsS3, {
                companionUrl: process.env.VUE_APP_API_URL + '/api/companion',
                getUploadParameters(file) {
                    return fetch(process.env.VUE_APP_API_URL + '/api/companion', {
                        method: 'post',
                        headers: {
                            accept: 'application/json',
                            'content-type': 'application/json'
                        },
                        body: JSON.stringify({
                            filename: self.generateId(20) + '.' + file.extension,
                            contentType: file.type,
                            origin_filename: file.name
                        })
                    }).then((response) => {
                        return response.json()
                    }).then((data) => {
                        return {
                            method: data.method,
                            url: data.url,
                            fields: data.fields,
                            headers: data.headers
                        }
                    })
                }
            })

            this.uppy.on('complete', (event) => {
                if (event.successful !== undefined) {
                    event.successful.forEach(async result => {
                        let path = result.response.body.location
                        let metadata = await this.getExifMetadata(path)

                        this.pushMedia(path, path, null, null, metadata.copyright, metadata.height, metadata.width)
                    })
                }

                this.uppy.reset()
            })

            this.loadCss()
        }
    }
}
</script>